<template>
  <div class="rootDiv">
    <Field label="抖音链接" placeholder="请粘贴分享的抖音链接" rows="7" type="textarea" v-model="douyinUrl"></Field>
    <Button size="large" class="addbutton" @click="StartWork">开始去水印</Button>
    <vueMiniPlayer
        v-if="showVideo"
        ref="vueMiniPlayer"
        :video="video"
        :mutex="true"
        @fullscreen="handleFullscreen"/>
    <Button size="large" v-if="showVideo" class="copy" @click="CopyUrl"
            style="margin-top: 0.5rem;margin-bottom: 0.5rem;background: lightseagreen">复制链接
    </Button>
    <Button size="large" v-if="showVideo" class="addbutton" @click="Download" style="margin-top: 0.5rem">下载视频</Button>
  </div>
</template>

<script>
import {Button, Field, Indicator} from "mint-ui";
import Clipboard from 'clipboard';
import FileSaver from 'file-saver';

export default {
  name: "DouyinTool",
  components: {
    Field, Button
  },
  data() {
    return {
      code: '20200829-20210324-20210329',
      douyinUrl: null,
      douyimUrl: '/api/business/douyin',
      token: localStorage.getItem('token'),
      yhnm: localStorage.getItem('yhnm'),
      isactivebrief: true,
      showVideo: false,
      video: {
        url: '',  //后端返回的视频地址
        cover: '',  //播放前默认展示的图片，提高用户体验
        muted: false,  //表示视频是否静音，默认false。
        loop: true,    //表示视频是否在结束时再播放
        preload: "auto",  //表示是否在完成页面加载后，载入视频，可选三个取值为：none、metadata、auto
        poster: "",   //显示您设置的图像，即一个带有预览图的视频播放
        volume: 1,    //将视频音量设置为100%，0.1为10%，以此类推
        autoplay: false,   //表示只要网页中的视频加载完成就会开始自动播放视频},
      },
    }
  },
  methods: {
    /**下载 */
    CopyUrl() {
      let that = this
      let copy = new Clipboard('.copy', {
        text() {
          return that.video.url
        }
      })
      //复制成功
      copy.on('success', () => {
        copy.destroy();//必须清空之前创建的实例！！！如果不信邪，自己多点两下复制按钮，F12看console
        that.$toast({
          message: '复制成功，再次使用该功能后，此链接将被替换。',
          position: 'middle',
        });
      })
      //复制失败，不支持
      copy.on('error', () => {
        copy.destroy();
        console.log('error')
      })
    },
    //视频下载
    Download() {
      let that = this
      if (that.isWeiXin()) {
        that.$messagebox.alert("请在浏览器中打开下载视频文件")
        return
      }
      Indicator.open({
        text: '正在下载视频...',
        spinnerType: 'fading-circle'
      });
      that.$ajax({
        method: 'get',
        url: that.video.url,
      }).then((response) => {
            const blob = new Blob([response.data]);
            FileSaver.saveAs(blob, '抖音视频.mp4');
            Indicator.close();
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
    handleFullscreen() {
    },
    StartWork() {
      let that = this
      that.showVideo = false
      if (that.douyinUrl === null || that.douyinUrl === '') {
        that.$messagebox.alert("请粘贴分享的抖音链接")
        return
      }
      Indicator.open({
        text: '正在处理视频...',
        spinnerType: 'fading-circle'
      });
      that.$ajax({
        method: 'get',
        url: that.douyimUrl,
        params: {yhnm: that.yhnm, url: that.douyinUrl},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
            Indicator.close();
            if (response.data.result) {
              that.showVideo = true
              let res = response.data['responseData']
              that.video.url = res['videoURL']
              that.video.cover = res['coverURL']
            } else
              that.$messagebox.alert(response.data.message)
          }
      ).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商" + response, '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin-top: -0.5rem;
}

.addbutton {
  background: lightseagreen;
  margin-bottom: 0.5rem;
}
</style>
